import { CssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { GlobalDesignAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';
import { ShadowStyleValue } from '../common/lobby/types';
import compareColors from '../common/grouping/compare/compareColors';
import { MergingStrategyConfig } from '../common/grouping/types';
import defaultValueMergingStrategy from '../common/grouping/defaultValueMergingStrategy';

export const shadowGrouping: GlobalDesignAction<'shadowStyles'>['grouping'] = {
  getGroupingStrategy: (editorPointer, getHost) => {
    return () => {
      return groupByGroupDefinitions(editorPointer, 'shadowStyles', getHost);
    };
  },

  applyValueMergingStrategy: (stylesGroups) => {
    const config: MergingStrategyConfig<'shadowStyles'> = {
      allowSubsets: false,
      valueComparator: {
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.boxShadow]: (
          value1: ShadowStyleValue,
          value2: ShadowStyleValue,
        ) =>
          // @ts-expect-error - TODO: ds-types-bump
          value1?.type === value2?.type &&
          // @ts-expect-error - TODO: ds-types-bump
          value1?.blurRadius === value2?.blurRadius &&
          // @ts-expect-error - TODO: ds-types-bump
          value1?.offsetX?.value === value2?.offsetX?.value &&
          // @ts-expect-error - TODO: ds-types-bump
          value1?.offsetY?.value === value2?.offsetY?.value &&
          // @ts-expect-error - TODO: ds-types-bump
          value1?.spreadRadius?.value === value2?.spreadRadius?.value &&
          // @ts-expect-error - TODO: ds-types-bump
          value1?.color?.type === value2?.color?.type &&
          // @ts-expect-error - TODO: ds-types-bump
          compareColors(value1?.color, value2?.color),
      },
    };

    return defaultValueMergingStrategy<'shadowStyles'>(stylesGroups, config);
  },
};
